// src/features/stats/DaypartChips.jsx
import React from "react";

const pill = (active) => ({
  padding: "6px 12px",
  borderRadius: 999,
  border: `1px solid ${active ? "#2b63b6" : "#2a3444"}`,
  background: active ? "#1c2f4f" : "#101723",
  color: active ? "#e7f1ff" : "#9fb0c2",
  cursor: "pointer",
  boxShadow: active ? "inset 0 0 0 1px #3b82f6" : "none",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  whiteSpace: "nowrap",
});

export default function DaypartChips({
  bucket,        // "", "overnight" | "morning" | "afternoon" | "evening"
  setBucket,
  sunMode,       // null | 1 (Dusk–Dawn) | 0 (Dawn–Dusk)
  setSunMode,
}) {
  // Back-compat: if "night" sneaks in, normalize to the new "overnight"
  const normBucket = bucket === "night" ? "overnight" : bucket;

  const selectAnytime = () => {
    setBucket("");
    setSunMode?.(null);
  };

  const selectClock = (b) => {
    setBucket(b);
    setSunMode?.(null); // clock chips clear sunlight mode
  };

  // IMPORTANT: do NOT call setBucket("") here.
  // Parent (FilterBar) already clears buckets when we set sunlight mode.
  const selectSun = (isNight) => {
    setSunMode?.(isNight); // 1 = Dusk–Dawn, 0 = Dawn–Dusk
  };

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
      <button style={pill(!normBucket && sunMode == null)} onClick={selectAnytime}>
        Anytime
      </button>

      <button
        style={pill(normBucket === "morning")}
        onClick={() => selectClock("morning")}
        title="6:00am–12:00pm"
      >
        Morning (6:00am–12:00pm)
      </button>

      <button
        style={pill(normBucket === "afternoon")}
        onClick={() => selectClock("afternoon")}
        title="12:00pm–6:00pm"
      >
        Afternoon (12:00pm–6:00pm)
      </button>

      <button
        style={pill(normBucket === "evening")}
        onClick={() => selectClock("evening")}
        title="6:00pm–12:00am"
      >
        Evening (6:00pm–12:00am)
      </button>

      <button
        style={pill(normBucket === "overnight")}
        onClick={() => selectClock("overnight")}
        title="12:00am–6:00am"
      >
        Overnight (12:00am–6:00am)
      </button>

      <button
        style={pill(sunMode === 1)}
        onClick={() => selectSun(1)}
        title="Sunlight-based: after dusk (+20m) to before dawn (−20m)"
      >
        Dusk–Dawn
      </button>

      <button
        style={pill(sunMode === 0)}
        onClick={() => selectSun(0)}
        title="Sunlight-based: after dawn (+20m) to before dusk (−20m)"
      >
        Dawn–Dusk
      </button>
    </div>
  );
}
